import { Report } from "../Interfaces/TableInterfaces";
import {
  downloadExcel,
  getTable,
  postRequest,
  getRequest,
  putRequest,
  deleteRequest,
  postDownloadExcel,
} from "./requestTemplates";
// Types
import type {
  IWorkingCalenderSearchParams,
  IWorkingCalenderTableReport,
} from "src/Interfaces/workingCalender";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Packet } from "src/Interfaces/commonDtos";
/**
 * working calendar
 * جدول تقویم کاری
 *
 * @param {IWorkingCalenderSearchParams} searchParam
 * @param {number | null} offset
 * @param {number | null} pageSize
 * @param {string} sortingType
 * @async
 * @version 1.4.0
 */
export const getWorkingCalenderTable = (
  searchParam: IWorkingCalenderSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IWorkingCalenderTableReport>> =>
  getTable<IWorkingCalenderSearchParams, IWorkingCalenderTableReport>(
    "/v1/Calender/workingDaysCalenderTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * working calendar
 * دراپ داون وضعیت
 *
 * @async
 * @version 1.4.0
 */
export const getWorkingDaysFilter = (): Promise<DropdownItem[]> =>
  getRequest("/v1/Calender/workingDaysFilterDropDown");

/**
 * working calendar
 * عملیات گروهی -> بازگشایی بورس کالا
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const toggleUpIsBourseKalaOpen = (
  ids: number[],
): Promise<Packet<boolean>> =>
  putRequest("/v1/Calender/toggleUpIsBourseKalaOpen", ids);

/**
 * working calendar
 * عملیات گروهی ->  تعطیلی بورس کالا
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const toggleDownIsBourseKalaOpen = (
  ids: number[],
): Promise<Packet<boolean>> =>
  putRequest("/v1/Calender/toggleDownIsBourseKalaOpen", ids);

/**
 * working calendar
 * عملیات گروهی -> بازگشایی بورس
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const toggleUpIsBourseOpen = (ids: number[]): Promise<Packet<boolean>> =>
  putRequest("/v1/Calender/toggleUpIsBourseOpen", ids);

/**
 * working calendar
 * عملیات گروهی -> تعطیلی بورس
 *
 * @param {ids} number[]
 * @async
 * @version 1.4.0
 */
export const toggleDownIsBourseOpen = (
  ids: number[],
): Promise<Packet<boolean>> =>
  putRequest(" /v1/Calender/toggleDownIsBourseOpen", ids);
